import { render, staticRenderFns } from "./ColorRegister.vue?vue&type=template&id=77b5d535&"
import script from "./ColorRegister.vue?vue&type=script&lang=js&"
export * from "./ColorRegister.vue?vue&type=script&lang=js&"
import style0 from "./ColorRegister.vue?vue&type=style&index=0&id=77b5d535&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports